import { PartTypeEnum } from '__generated__/types';
import type { Locale } from 'antd/es/locale';
import bg from 'antd/es/locale/bg_BG';
import cs from 'antd/es/locale/cs_CZ';
import de from 'antd/es/locale/de_DE';
import el from 'antd/es/locale/el_GR';
import en from 'antd/es/locale/en_US';
import es from 'antd/es/locale/es_ES';
import fr from 'antd/es/locale/fr_FR';
import hi from 'antd/es/locale/hi_IN';
import hr from 'antd/es/locale/hr_HR';
import hu from 'antd/es/locale/hu_HU';
import it from 'antd/es/locale/it_IT';
import lt from 'antd/es/locale/lt_LT';
import lv from 'antd/es/locale/lv_LV';
import pl from 'antd/es/locale/pl_PL';
import ro from 'antd/es/locale/ro_RO';
import sk from 'antd/es/locale/sk_SK';
import sl from 'antd/es/locale/sl_SI';
import tr from 'antd/es/locale/tr_TR';
import cn from 'antd/es/locale/zh_CN';
import { CURRENT_REGION } from 'common/config/regions/config';
import { Regions } from 'common/config/regions/types';
import { DecisionState, ResponseState } from 'common/interfaces';
import { LabelTypes } from 'components/Label/Label';
import { TFunction } from 'i18next';

export const DECISION_MAPPING: Record<DecisionState, { label: (t: TFunction) => string; labelType: LabelTypes }> = {
  pending: {
    label: (t) => t('responses.statuses.waitingForDecision'),
    labelType: 'warning',
  },
  auto_accepted: {
    label: (t) => t('responses.statuses.acceptedByXometry'),
    labelType: 'success',
  },
  accepted: {
    label: (t) => t('responses.statuses.acceptedByXometry'),
    labelType: 'success',
  },
  rejected: {
    label: (t) => t('responses.statuses.rejectedByXometry'),
    labelType: 'error',
  },
  rejected_by_partner: {
    label: (t) => t('responses.statuses.canceledByPartner'),
    labelType: 'error',
  },
  irrelevant: {
    label: (t) => t('responses.statuses.irrelevant'),
    labelType: 'error',
  },
};

export const RESPONSE_MAPPING: Record<ResponseState, string> = {
  empty: '',
  application: 'commonPhrases.application',
  counteroffer: 'commonPhrases.counteroffer',
  irrelevant: 'commonPhrases.irrelevant',
};

export const PROVIDER_COUNTRIES_FOR_SELF_BILLING = [
  'Germany',
  'China',
  'India',
  'Lithuania',
  'Viet Nam',
  'Romania',
  'Croatia',
];

export const DEFAULT_PAGE_SIZE = 10;
export const REGULAR_MONTHLY_PAYMENTS_TAG = 'Regular Monthly Payments';

export const ANT_LOCALE_MAPPING: Record<string, Locale> = {
  tr: tr,
  en: en,
  de: de,
  es: es,
  pl: pl,
  fr: fr,
  it: it,
  el: el,
  bg: bg,
  ro: ro,
  hi: hi,
  cs: cs,
  hr: hr,
  lt: lt,
  lv: lv,
  hu: hu,
  sk: sk,
  sl: sl,
  cn: cn,
};

export const sortingPositions: PartTypeEnum[] = [PartTypeEnum.Standard, PartTypeEnum.Mold, PartTypeEnum.CustomerObject];

export const IS_EU = CURRENT_REGION === Regions.EU;
export const IS_TR = CURRENT_REGION === Regions.TR;
export const IS_UK = CURRENT_REGION === Regions.UK;
export const IS_SG = CURRENT_REGION === Regions.SG;
